import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartTourPopupComponent } from './start-tour-popup.component';
import { SvgQrcodeModule } from '../svg-qrcode/svg-qrcode.module';



@NgModule({
    declarations: [
        StartTourPopupComponent
    ],
    exports: [
        StartTourPopupComponent
    ],
    imports: [
        CommonModule,
        SvgQrcodeModule
    ]
})
export class StartTourPopupModule { }
